document.addEventListener("DOMContentLoaded", function() {
	$.fn.isInViewport = function() {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();
	
		var viewportTop = $("#content").scrollTop();
		var viewportBottom = viewportTop + $("#content").height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	$(".counter").each(function(){
		var number = $(this).text();
		var numberCount = parseFloat(number.replace(/[^0-9.\-]/g, ''));
		var numberCountString = numberCount.toString();

		$(this).html(numberCount);

		if ($(this).hasClass("counter-slow")) {
			var durationSpeed = 4000;
		} else if ($(this).hasClass("counter-normal")) {
			var durationSpeed = 2000;
		} else {
			var durationSpeed = 1000;
		}

		if (numberCount !== Math.floor(numberCount)) {
			var decimalCount = parseInt(numberCountString.length - numberCountString.indexOf(".") - 1);
			$(this).countimator({
				max: numberCount,
				decimals: decimalCount,
				duration: durationSpeed,
			});
		} else {
			$(this).countimator({
				max: numberCount,
				thousandDelimiter: ",",
				duration: durationSpeed,
			});
		}

		function is_numeric(str){
			return /^\d+$/.test(str);
		}

		if (!is_numeric(number.charAt(0))) {
			var preContent = number.replace(/[0-9.\-]/g, '');
			$(this).attr("data-pre-content", preContent);
		} else {
			var postContent = number.replace(/[0-9.\-]/g, '');
			$(this).attr("data-post-content", postContent);
		}
	});
});